
















































































import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { Intervention } from "../../models/Intervention";
import { TableColumn } from "../../models/UI/TableColumn";
import { Option } from "../../models/Option";
import { ContactApi } from "../../api/ContactApi";
import { EmployeApi } from "../../api/EmployeApi";
import moment from "moment";
import { Routes } from "../../utils/Routes";

export default {
    name: "InterventionsListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            selectedFilter: null,
            EEtat: Intervention.EEtat,
            ContactApi: new ContactApi(),
            EmployeApi: new EmployeApi(),
            intervention_print_planning_url: Routes.intervention_print_planning,
            columns: [
                {
                    id: "id",
                    name: "N° d'intervention",
                    type: TableColumn.ColumnType.text,
                    // Filtre posé uniquement via l'URL (lien de la modale) : exclu du dropdown
                    hidden: true,
                },
                {
                    id: "horaireDebut",
                    name: "Horaire prévu",
                    type: TableColumn.ColumnType.text,
                    sort_field: "horaire_debut",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.asc,
                },
                {
                    id: "horaireEffectif",
                    name: "Horaire effectif",
                    //type: TableColumn.ColumnType.text,
                    sort_field: "heure_reelle_debut_intervention",
                },
                {
                    id: "employeIds",
                    name: "Employé",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "employes.nom",
                },
                {
                    id: "clientIds",
                    name: "Copropriété",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "titre",
                    name: "Description",
                    type: TableColumn.ColumnType.text,
                },
                {
                    id: "datePrevue",
                    name: "Date prévue",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "date_prevue_intervention",
                    default_filter: true,
                    default_value: { start: moment(), end: moment() },
                },
                {
                    id: "dateReelle",
                    name: "Date réelle",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "date_reelle_intervention",
                },
                {
                    id: "dureePrevue",
                    name: "Durée prévue",
                    //type: TableColumn.ColumnType.number,
                    sort_field: "duree_prevue",
                },
                {
                    id: "dureeReelle",
                    name: "Durée réelle",
                    sort_field: "duree_reelle",
                },
                {
                    id: "frequenceIds",
                    name: "Fréquence",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                },
                {
                    id: "to_notify",
                    name: "Prioritaire",
                    type: TableColumn.ColumnType.boolean,
                    sort_field: "to_notify",
                },
                {
                    id: "nonFacturation",
                    name: "Non facturation",
                    type: TableColumn.ColumnType.boolean,
                },
                {
                    id: "anomalies",
                    name: "Anomalies",
                    type: TableColumn.ColumnType.boolean,
                },
                {
                    id: "photos",
                    name: "Photos",
                    sort_field: "photos_count",
                },
            ],
        };
    },
    created() {
        let self = this;
        self.ContactApi.getAllAsOptions({ useCache: true }).then(function (
            res
        ) {
            let col = _.find(self.columns, { id: "clientIds" });
            col.options = Option.toTags(
                _.filter(res, function (c) {
                    return !!c.name;
                })
            );
            let coproprietes_sensibles_ids = _.chain(res)
                .filter(function (c) {
                    return c.classes === "important-tag";
                })
                .map("id")
                .value();
            col.options.push({
                ids: coproprietes_sensibles_ids,
                text: "Copropriétés sensibles",
                classes: "group-tag",
            });
            col.options.push({
                ids: [-1],
                text: "Vide",
                classes: "empty-tag",
            });
        });
        self.EmployeApi.getAllAsOptions().then(function (res) {
            let col = _.find(self.columns, { id: "employeIds" });
            col.options = Option.toTags(res);
            col.options.push({
                ids: [-1],
                text: "Vide",
                classes: "empty-tag",
            });
            col.options.push({
                ids: [-2],
                text: "Employés test",
                classes: "empty-tag",
            });
        });
        let col = _.find(self.columns, { id: "frequenceIds" });
        col.options = Option.toTags(Intervention.Frequence);
    },
    beforeMount() {
        let self = this;
        if (self.defaultFilters) {
            if (self.defaultFilters.has("id")) {
                let idCol = _.find(self.columns, { id: "id" });
                idCol.default_filter = true;
                idCol.default_value = self.defaultFilters.get("id");
                // Ne pas restreindre à la date du jour quand on cible une intervention précise
                let dateCol = _.find(self.columns, { id: "datePrevue" });
                dateCol.default_filter = false;
            }

            if (
                self.defaultFilters.has("start_date") &&
                self.defaultFilters.has("end_date")
            ) {
                let col = _.find(self.columns, { id: "datePrevue" });
                col.default_value = {
                    start: moment(self.defaultFilters.get("start_date")),
                    end: moment(self.defaultFilters.get("end_date")),
                };
            }

            if (self.defaultFilters.has("unassigned_only")) {
                let col = _.find(self.columns, { id: "employeIds" });
                col.default_filter = true;
                col.default_value = [
                    {
                        ids: [-1],
                        text: "Vide",
                        classes: "empty-tag",
                    },
                ];
            }
            if (self.defaultFilters.has("test_only")) {
                let col = _.find(self.columns, { id: "employeIds" });
                col.default_filter = true;
                col.default_value = _.concat(col.default_value, [
                    {
                        ids: [-2],
                        text: "Employés test",
                        classes: "empty-tag",
                    },
                ]);
            }
            if (
                self.defaultFilters.has("employe_id") &&
                self.defaultFilters.has("employe_nom")
            ) {
                let col = _.find(self.columns, { id: "employeIds" });
                col.default_filter = true;
                col.default_value = [
                    {
                        ids: [self.defaultFilters.get("employe_id")],
                        text: self.defaultFilters.get("employe_nom"),
                        classes: "",
                    },
                ];
            }

            if (self.defaultFilters.has("frequences")) {
                let col = _.find(self.columns, { id: "frequenceIds" });
                let freqIds = self.defaultFilters.getAll("frequences");
                col.default_filter = true;
                col.default_value = _.map(freqIds, function (f) {
                    return {
                        ids: [f],
                        text: Intervention.Frequence[f].shortname,
                    };
                });
            }

            if (self.defaultFilters.has("default_sort_id")) {
                let defaultCol = _.find(self.columns, { default_sort: true });
                if (defaultCol) {
                    defaultCol.default_sort = false;
                }
                let newCol = _.find(self.columns, {
                    id: self.defaultFilters.get("default_sort_id"),
                });
                if (newCol) {
                    newCol.default_sort = true;
                    if (self.defaultFilters.has("default_sort_order")) {
                        newCol.default_value =
                            self.defaultFilters.get("default_sort_order");
                    }
                }
            }
        }
    },
    methods: {
        selectFilter: function (filter) {
            if (this.selectedFilter === filter) {
                this.selectedFilter = null;
            } else {
                this.selectedFilter = filter;
            }
            this.$emit("input", this.getFilters());
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            // Filtre copropriété vide
            if (
                this.filters.clientIds &&
                _.includes(this.filters.clientIds, "-1")
            ) {
                this.filters.emptyClient = true;
            }
            // Filtre employé vide
            if (
                this.filters.employeIds &&
                _.includes(this.filters.employeIds, "-1")
            ) {
                this.filters.emptyEmploye = true;
            }
            // Filtre employés test
            if (
                this.filters.employeIds &&
                _.includes(this.filters.employeIds, "-2")
            ) {
                this.filters.testEmploye = true;
            }
            // Filtre status
            if (_.isNull(this.selectedFilter)) {
                return _.merge({}, this.filters, {
                    taskView: this.taskView,
                });
            } else {
                let etatFilter = this.selectedFilter;
                if (this.selectedFilter === Intervention.EEtat.Finished) {
                    etatFilter += "," + Intervention.EEtat.Archived;
                }
                return _.merge({}, this.filters, {
                    etat: etatFilter,
                    taskView: this.taskView,
                });
            }
        },
        // UI
        addIntervention() {
            this.$emit("action", Intervention.UIActionType.create_intervention);
        },
    },
};
